var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('files-tank-card-usages-upload'),_vm._v(" "),_c('br'),_vm._v(" "),_c('files-tank-card-usages-table',{attrs:{"files-under-processing":_vm.filesUnderProcessing,"files-processed":_vm.filesProcessed}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }